import { apiCreateDirectOrder, apiVerifySignature } from "@/api";
import { toast } from "sonner";

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

// Opens Razorpay for a single amount (flight/hotel wizards).
// Resolves with { paymentId } on verified success, or null on cancel/fail.
export async function payWithRazorpay({ amount, purpose, contact, description }) {
  const ok = await loadRazorpay();
  if (!ok) { toast.error("Could not load payment gateway. Try again."); return null; }
  const order = await apiCreateDirectOrder({ amount, purpose });
  return new Promise((resolve) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "FLYTRIP",
      description: description || "Booking payment",
      prefill: { name: contact?.name || "", email: contact?.email || "", contact: contact?.phone || "" },
      theme: { color: "#1B1F5B" },
      handler: async (resp) => {
        try {
          const res = await apiVerifySignature({
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          resolve({ paymentId: res.payment_id });
        } catch {
          toast.error("Payment verification failed. If money was deducted, contact support.");
          resolve(null);
        }
      },
      modal: { ondismiss: () => { toast.info("Payment cancelled"); resolve(null); } },
    });
    rzp.on("payment.failed", (r) => { toast.error(r?.error?.description || "Payment failed"); resolve(null); });
    rzp.open();
  });
}
